import { render, staticRenderFns } from "./ProformaListPage.vue?vue&type=template&id=3a25d5d8&scoped=true&"
import script from "./ProformaListPage.vue?vue&type=script&lang=js&"
export * from "./ProformaListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25d5d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a25d5d8')) {
      api.createRecord('3a25d5d8', component.options)
    } else {
      api.reload('3a25d5d8', component.options)
    }
    module.hot.accept("./ProformaListPage.vue?vue&type=template&id=3a25d5d8&scoped=true&", function () {
      api.rerender('3a25d5d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/ProformaListPage.vue"
export default component.exports